import React, { useEffect, useState, useRef } from "react";
import { submitVote, likeDislike, addComment, getAllComments, getAllBookmark, deleteBookmark, deleteComment } from "../../api/Vote";
import { getUser } from "../../api/auth";
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ShareIcon from '@mui/icons-material/Share';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import CircularProgress from '@mui/material/CircularProgress';
import FaceRecognition from '../FaceRecognition/FaceRecognition';
import CloseIcon from '@mui/icons-material/Close';
import Loader from '../Loader';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff'; 
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import FavoriteBorderRoundedIcon from '@mui/icons-material/FavoriteBorderRounded';
import KeyboardArrowUpRoundedIcon from '@mui/icons-material/KeyboardArrowUpRounded';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';
import NearMeOutlinedIcon from '@mui/icons-material/NearMeOutlined';
import humanizeDuration from 'humanize-duration';
import { getUserId, getToken } from '../../api/index';
import { getHumanizedTime } from '../getHumanizedTime';
import useGovtIdVerification from '../../hooks/useGovtIdVerification';
import ProfileCompletionPrompt from '../Shared/ProfileCompletionPrompt';
import ShareModal from '../Shared/ShareModal';

function SavedVote() {
  const [allVotes, setAllVotes] = useState([]);
  const userId = getUserId();
  const token = getToken();
  const [openComments, setOpenComments] = useState({});
  const [commentText, setCommentText] = useState("");
  const [allComments, setAllComments] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
  const [selectedCardId, setSelectedCardId] = useState(null);
  const [selectedCardBookmarkId, setSelectedCardBookmarkId] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState({});
  const [filePreviews, setFilePreviews] = useState({});
  const fileInputRef = useRef(null);
  const [shareDialogOpen, setShareDialogOpen] = useState(false);
  const [selectedVoteForShare, setSelectedVoteForShare] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [faceRecognitionDialogOpen, setFaceRecognitionDialogOpen] = useState(false);
  const [pendingVote, setPendingVote] = useState(null);
  const [isSignIn, setIsSignIn] = useState(false);
  const [unmutedVideoId, setUnmutedVideoId] = useState(null);
  const [isUserVerified, setIsUserVerified] = useState('');
  const [playingVideos, setPlayingVideos] = useState({});
  const [imageLoading, setImageLoading] = useState({});
  const [videoLoading, setVideoLoading] = useState({});
  const [commentMediaLoading, setCommentMediaLoading] = useState({});
  const [previewLoading, setPreviewLoading] = useState({});
  const [profileImageLoading, setProfileImageLoading] = useState({});
  const [commentProfileLoading, setCommentProfileLoading] = useState({});
  const [commentLoader, setCommentLoader] = useState(false);
  const [profilePromptOpen, setProfilePromptOpen] = useState(false);
  const [profilePromptMessage, setProfilePromptMessage] = useState('');
  const govtHook = useGovtIdVerification();
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [isSubscriptionEnable, setIsSubscriptionEnable] = useState(false);

  useEffect(() => {
    handleBookmarkedVotes();
  }, []);

  useEffect(() => {
    const getUserDetails = async () => {
      const response = await getUser(userId, token);
      console.log(" response from getUser api:", response.data);
      if (response.data?.governmentId === null) {
        setIsUserVerified('notUploaded');
      } else if (response.data?.governmentId?.isVerified === true) {
        setIsUserVerified('verified');
      } else if (response.data?.governmentId?.verificationStatus === 'rejected') {
        setIsUserVerified('rejected');
      }
      else {
        setIsUserVerified('pending');
      }
    }
    getUserDetails();
  }, []);

  // Only check isSubscribed if isSubscriptionEnable is true
  // useEffect(() => {
  //   if (storedUserDetails) {
  //     setIsSubscribed(!!storedUserDetails.isSubscribed);
  //     setIsSubscriptionEnable(!!storedUserDetails.isSubscriptionEnable);
  //   }
  // }, [storedUserDetails]);

  // Effect to handle body scrolling when popup is open
  useEffect(() => {
    if (showPopup) {
      // Disable scrolling
      document.body.style.overflow = 'hidden';
    } else {
      // Re-enable scrolling
      document.body.style.overflow = 'unset';
    }

    // Cleanup function to ensure scrolling is re-enabled when component unmounts
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [showPopup]);

  const handleBookmarkedVotes = async () => {
    setIsLoading(true);
    try {
      const response = await getAllBookmark(token);
      console.log(" response from getAllBookmark api:", response);
      setAllVotes(response.map(item => ({
        ...item.voteDetails,
        bookmarkId: item.bookmarkId
      })));
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmitVote = async (voteId, optionId) => {
    const govCheck = govtHook.check();
    if (!govCheck.allowed) {
      setProfilePromptMessage(govCheck.reason);
      setProfilePromptOpen(true);
      return;
    }
    if (isSubscriptionEnable && !isSubscribed) {
      setSnackbarMessage('Subscription required to vote.');
      setSnackbarOpen(true);
      return;
    }
    console.log("voteId", voteId);
    setPendingVote({ voteId, optionId });
    setFaceRecognitionDialogOpen(true);
  }

  useEffect(() => {
    if (isSignIn && pendingVote) {
      const submit = async () => {
        try {
          const response = await submitVote({ voteId: pendingVote.voteId, userId, optionId: pendingVote.optionId }, token);
          console.log(" response from submitVote api:", response);
          setAllVotes(prevVotes =>
            prevVotes.map(vote => {
              if (vote.voteId === pendingVote.voteId) {
                return {
                  ...vote,
                  options: vote.options.map(option => ({
                    ...option,
                    isSelected: option.id === pendingVote.optionId
                  }))
                };
              }
              return vote;
            })
          );
          handleBookmarkedVotes();
          setSnackbarMessage('Vote submitted successfully!');
          setSnackbarOpen(true);
        } catch (error) {
          console.log("error", error);
          setSnackbarMessage('Failed to submit vote. Please try again.');
          setSnackbarOpen(true);
        }
        setIsSignIn(false);
        setFaceRecognitionDialogOpen(false);
        setPendingVote(null);
      };
      submit();
    }
  }, [isSignIn, pendingVote]);

  const handleLikeDislike = async (voteId) => {
    const govCheck = govtHook.check();
    if (!govCheck.allowed) {
      setProfilePromptMessage(govCheck.reason);
      setProfilePromptOpen(true);
      return;
    }
    if (isSubscriptionEnable && !isSubscribed) {
      setSnackbarMessage('Subscription required to like.');
      setSnackbarOpen(true);
      return;
    }
    console.log("voteId", voteId);
    try {
      const response = await likeDislike({ voteId, userId }, token);
      console.log(" response from likeDislike api:", response);
      setAllVotes(prevVotes =>
        prevVotes.map(vote => {
          if (vote.voteId === voteId) {
            return {
              ...vote,
              isLiked: !vote.isLiked,
              likeCount: vote.isLiked ? vote.likeCount - 1 : vote.likeCount + 1
            };
          }
          return vote;
        })
      );
    } catch (error) {
      console.log("error", error);
    }
  }

  const handleCommentLikeDislike = async (voteId, commentId, action) => {
    const comment = allComments.find(c => c.commentId === commentId);
    if (!comment) return;

    if (action === 'up' && comment.isLiked) return;
    if (action === 'down' && !comment.isLiked) return;

    const token = getToken();
    const userId = getUserId();
    const govCheck = govtHook.check();
    if (!govCheck.allowed) {
      setProfilePromptMessage(govCheck.reason);
      setProfilePromptOpen(true);
      return;
    }

    try {
      const response = await likeDislike({ voteId, userId, targetId: commentId, targetType: 1 }, token);
      console.log(" response from comment likeDislike api:", response);
      setAllComments(prevComments => {
        let updated = prevComments.map(c => {
          if (c.commentId === commentId) {
            return {
              ...c,
              isLiked: !c.isLiked,
              likeCount: c.isLiked ? Math.max(0, c.likeCount - 1) : c.likeCount + 1
            };
          }
          return c;
        });
        return updated.sort((a, b) => b.likeCount - a.likeCount);
      });
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleCommentIconClick = async (voteId, commentCount) => {
    // Close all other open comments except the one being toggled
    setOpenComments(prev => {
      const newState = {};
      // If we're opening this comment section, close all others and open this one
      if (!prev[voteId]) {
        newState[voteId] = true;
      }
      // If we're closing this comment section, just close it
      return newState;
    });

    // Clear any existing file previews and selections
    setSelectedFiles({});
    setFilePreviews(prev => {
      // Cleanup existing preview URLs
      Object.values(prev).forEach(url => {
        URL.revokeObjectURL(url);
      });
      return {};
    });
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }

    // Clear comments when closing
    if (openComments[voteId]) {
      setAllComments([]);
      return;
    }

    // Always clear comments first when opening a comment section
    setAllComments([]);

    // Fetch comments when opening and there are comments
    if (commentCount > 0) {
      try {
        const response = await getAllComments(voteId, token);
        console.log(" response from getAllComments api:", response);
        const sortedComments = [...(response.comments || [])].sort((a, b) => b.likeCount - a.likeCount);
        setAllComments(sortedComments);
      } catch (error) {
        console.log("error", error);
      }
    }
  };

  const handleCommentSubmit = async (voteId) => {
    const govCheck = govtHook.check();
    if (!govCheck.allowed) {
      setProfilePromptMessage(govCheck.reason);
      setProfilePromptOpen(true);
      return;
    }
    if (commentLoader) return;
    if (isSubscriptionEnable && !isSubscribed) {
      setSnackbarMessage('Subscription required to comment.');
      setSnackbarOpen(true);
      return;
    }
    setCommentLoader(true);
    console.log("commentText", commentText);
    console.log("voteId", voteId);
    try {
      const formData = new FormData();
      formData.append("voteId", voteId);
      formData.append("userId", userId);

      if (commentText.length > 0) {
        formData.append("commentText", commentText);
      } else if (selectedFiles[voteId]) {
        const file = selectedFiles[voteId];
        console.log("File being sent:", file);

        // Append the file with its original name
        formData.append("Video", file);
      }
      const response = await addComment(formData, token);
      console.log(" response from addComment api:", response);

      // Clear the input after successful submission
      setCommentText("");
      if (selectedFiles[voteId]) {
        clearFileSelection(voteId);
      }

      // Update UI
      setAllVotes(prevVotes =>
        prevVotes.map(vote => {
          if (vote.voteId === voteId) {
            return {
              ...vote,
              commentCount: vote.commentCount + 1
            };
          }
          return vote;
        })
      );

      // Refresh comments
      const commentsResponse = await getAllComments(voteId, token);
      const sortedComments = [...(commentsResponse.comments || [])].sort((a, b) => b.likeCount - a.likeCount);
      setAllComments(sortedComments);
    } catch (error) {
      console.log("error", error);
    } finally {
      setCommentLoader(false);
    }
  };

  const handleFileSelect = (e, voteId) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFiles(prev => ({
        ...prev,
        [voteId]: file
      }));

      // Create preview URL
      const previewUrl = URL.createObjectURL(file);
      setFilePreviews(prev => ({
        ...prev,
        [voteId]: previewUrl
      }));

      // Clear text if there was any
      setCommentText("");
    }

    // Render ProfileCompletionPrompt
    // placed near bottom so it overlays appropriately when opened

  };

  const handlePlusClick = () => {
    fileInputRef.current?.click();
  };

  const clearFileSelection = (voteId) => {
    // Clear the specific file and preview
    setSelectedFiles(prev => {
      const newFiles = { ...prev };
      delete newFiles[voteId];
      return newFiles;
    });

    setFilePreviews(prev => {
      const newPreviews = { ...prev };
      if (newPreviews[voteId]) {
        URL.revokeObjectURL(newPreviews[voteId]);
        delete newPreviews[voteId];
      }
      return newPreviews;
    });

    // Reset the file input value
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  // Clean up preview URLs when component unmounts
  useEffect(() => {
    return () => {
      // Cleanup all previews
      Object.values(filePreviews).forEach(url => {
        URL.revokeObjectURL(url);
      });
    };
  }, [filePreviews]);

  const handleHelpClick = (e, cardId, bookmarkId) => {
    e.preventDefault();
    e.stopPropagation();
    const rect = e.currentTarget.getBoundingClientRect();

    // Get viewport dimensions
    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;

    // Estimate popup dimensions (you can adjust these based on your CSS)
    const popupHeight = 200; // Adjust based on your popup height
    const popupWidth = 250; // Adjust based on your popup width

    // Calculate available space
    const spaceBelow = viewportHeight - rect.bottom;
    const spaceAbove = rect.top;
    const spaceRight = viewportWidth - rect.right;
    const spaceLeft = rect.left;

    // Determine vertical position
    let top;
    if (spaceBelow >= popupHeight) {
      // Position below the button
      top = rect.bottom;
    } else if (spaceAbove >= popupHeight) {
      // Position above the button
      top = rect.top - popupHeight;
    } else {
      // Center vertically if neither space is sufficient
      top = Math.max(0, (viewportHeight - popupHeight) / 2);
    }

    // Determine horizontal position
    let left;
    if (spaceLeft >= popupWidth) {
      // Position to the left of the button (current behavior)
      left = rect.left - popupWidth;
    } else if (spaceRight >= popupWidth) {
      // Position to the right of the button
      left = rect.right;
    } else {
      // Center horizontally if neither space is sufficient
      left = Math.max(0, (viewportWidth - popupWidth) / 2);
    }

    setPopupPosition({
      top: top,
      left: left
    });
    setSelectedCardId(cardId);
    setSelectedCardBookmarkId(bookmarkId);
    setShowPopup(true);
  };

  const handleClickOutside = (e) => {
    if (e.target.className === 'popupOverlay') {
      setShowPopup(false);
    }
  };

  const handleUnSave = async (voteId) => {
    setShowPopup(false);
    const bookmarkId = selectedCardBookmarkId;
    try {
      const response = await deleteBookmark({ voteId, userId, bookmarkId }, token);
      console.log(" response from deleteBookmark api:", response);
      handleBookmarkedVotes();
      setSnackbarMessage('Unsaved successfully');
      setSnackbarOpen(true);
    } catch (error) {
      console.log("error", error);
      setSnackbarMessage('Failed to unsave. Please try again.');
      setSnackbarOpen(true);
    }
  };



  const handleDeleteComment = async (commentId, voteId) => {
    try {
      const response = await deleteComment({ commentId, userId }, token);
      console.log(" response from deleteComment api:", response);

      if (response) {
        // Update UI by removing the deleted comment
        setAllComments(prevComments =>
          prevComments.filter(comment => comment.commentId !== commentId)
        );

        // Update the comment count in the vote
        setAllVotes(prevVotes =>
          prevVotes.map(vote => {
            if (vote.voteId === voteId) {
              return {
                ...vote,
                commentCount: vote.commentCount - 1
              };
            }
            return vote;
          })
        );
      } else {
        throw new Error('Failed to delete comment');
      }

    } catch (error) {
      console.error("Error deleting comment:", error);
    }
  };

  const handleShare = (vote) => {
    console.log("Share clicked for vote:", vote);
    setSelectedVoteForShare(vote);
    setShareDialogOpen(true);
  };

  const handleSystemShare = async () => {
    console.log("System share clicked for vote:", selectedVoteForShare);
    if (navigator.share) {
      try {
        const shareUrl = `${window.location.origin}/vote?voteId=${selectedVoteForShare.voteId}`;
        console.log("Sharing URL:", shareUrl);
        await navigator.share({
          title: selectedVoteForShare.title,
          text: selectedVoteForShare.description,
          url: shareUrl
        });
        setShareDialogOpen(false);
      } catch (error) {
        console.log('Error sharing:', error);
      }
    }
  };

  const handleCopyLink = () => {
    console.log("Copy link clicked for vote:", selectedVoteForShare);
    const link = `${window.location.origin}/vote?voteId=${selectedVoteForShare.voteId}`;
    console.log("Copying URL:", link);
    navigator.clipboard.writeText(link).then(() => {
      setSnackbarMessage('Link copied to clipboard!');
      setSnackbarOpen(true);
      setShareDialogOpen(false);
    }).catch(err => {
      console.error('Failed to copy:', err);
      setSnackbarMessage('Failed to copy link');
      setSnackbarOpen(true);
    });
  };

  const handleVolumeToggle = (voteId, event) => {
    event.stopPropagation();
    setUnmutedVideoId(unmutedVideoId === voteId ? null : voteId);
  };

  const handleVideoPlayPause = (voteId, event) => {
    event.stopPropagation();
    const videoElement = event.target.closest('.voteMediaContainer').querySelector('video');

    if (videoElement) {
      if (playingVideos[voteId]) {
        videoElement.pause();
        setPlayingVideos(prev => ({ ...prev, [voteId]: false }));
      } else {
        videoElement.play();
        setPlayingVideos(prev => ({ ...prev, [voteId]: true }));
      }
    }
  };

  const handleFaceRecognitionSuccess = () => {
    setIsSignIn(true);
  };

  // Helper function to get user initials
  const getUserInitials = (userName) => {
    if (!userName) return '';
    const words = userName.trim().split(' ');
    if (words.length === 1) {
      return words[0].charAt(0).toUpperCase();
    }
    const firstInitial = words[0] ? words[0].charAt(0).toUpperCase() : '';
    const lastInitial = words[words.length - 1] ? words[words.length - 1].charAt(0).toUpperCase() : '';
    return firstInitial + lastInitial;
  };

  // Helper function to generate background color based on initials
  const getBackgroundColor = (initials) => {
    const colors = [
      '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4',
      '#FFEAA7', '#DDA0DD', '#98D8C8', '#F7DC6F',
      '#BB8FCE', '#85C1E9', '#F8C471', '#82E0AA'
    ];

    let hash = 0;
    for (let i = 0; i < initials.length; i++) {
      hash = initials.charCodeAt(i) + ((hash << 5) - hash);
    }
    hash = Math.abs(hash);
    return colors[hash % colors.length];
  };


  // Helper functions for loading states
  const handleImageLoad = (id, type) => {
    if (type === 'main') {
      setImageLoading(prev => ({ ...prev, [id]: false }));
    } else if (type === 'profile') {
      setProfileImageLoading(prev => ({ ...prev, [id]: false }));
    } else if (type === 'comment') {
      setCommentMediaLoading(prev => ({ ...prev, [id]: false }));
    } else if (type === 'preview') {
      setPreviewLoading(prev => ({ ...prev, [id]: false }));
    } else if (type === 'commentProfile') {
      setCommentProfileLoading(prev => ({ ...prev, [id]: false }));
    }
  };

  const handleImageError = (id, type) => {
    if (type === 'main') {
      setImageLoading(prev => ({ ...prev, [id]: false }));
    } else if (type === 'profile') {
      setProfileImageLoading(prev => ({ ...prev, [id]: false }));
    } else if (type === 'comment') {
      setCommentMediaLoading(prev => ({ ...prev, [id]: false }));
    } else if (type === 'preview') {
      setPreviewLoading(prev => ({ ...prev, [id]: false }));
    } else if (type === 'commentProfile') {
      setCommentProfileLoading(prev => ({ ...prev, [id]: false }));
    }
  };

  const handleVideoLoad = (id, type) => {
    if (type === 'main') {
      setVideoLoading(prev => ({ ...prev, [id]: false }));
    } else if (type === 'comment') {
      setCommentMediaLoading(prev => ({ ...prev, [id]: false }));
    } else if (type === 'preview') {
      setPreviewLoading(prev => ({ ...prev, [id]: false }));
    }
  };

  const setMediaLoading = (id, type, isLoading) => {
    if (type === 'main-image') {
      setImageLoading(prev => ({ ...prev, [id]: isLoading }));
    } else if (type === 'main-video') {
      setVideoLoading(prev => ({ ...prev, [id]: isLoading }));
    } else if (type === 'profile') {
      setProfileImageLoading(prev => ({ ...prev, [id]: isLoading }));
    } else if (type === 'comment') {
      setCommentMediaLoading(prev => ({ ...prev, [id]: isLoading }));
    } else if (type === 'preview') {
      setPreviewLoading(prev => ({ ...prev, [id]: isLoading }));
    } else if (type === 'commentProfile') {
      setCommentProfileLoading(prev => ({ ...prev, [id]: isLoading }));
    }
  };

  console.log("allVotes", allVotes);
  return (
    <div className="Feeds">
      <div className="feedsContainer">
        {isLoading ? (
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '40vh', width: '100%', gap: '20px' }}>
            <Loader containerSize="3rem" />
            <p style={{
              color: '#ffffff',
              fontWeight: '600',
              fontSize: '1rem',
              textTransform: 'uppercase',
              letterSpacing: '1.5px',
              textAlign: 'center',
              maxWidth: '90%',
              lineHeight: '1.4',
              fontFamily: '"Inter", sans-serif',
              opacity: 0.8
            }}>
              Hang tight, we’re getting things ready for you...
            </p>
          </div>

        ) : allVotes.length === 0 ? (
          <div className="feedCardContainer" style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '50vh',
            textAlign: 'center',
            padding: '40px 20px'
          }}>
            <div className="noVotesMessage">
              <h3 style={{ color: '#666', marginBottom: '8px', fontSize: '24px' }}>No Saved Votes</h3>
              <p style={{ color: '#999', textAlign: 'center', fontSize: '16px', maxWidth: '400px' }}>
                You haven't saved any votes yet. Start exploring and save votes that interest you!
              </p>
            </div>
          </div>
        ) : (
          <div className="feedCardContainer">
            {allVotes.map((item, index) => (
              <div key={index} className="feedCard">
                <div className="feedBody">
                  <div className="feedCardHeader">
                    <div className="profileDetailsContainer">
                      {item.createdByUserPhoto ? (
                        <div style={{ position: 'relative' }}>
                          {profileImageLoading[item.voteId] && (
                            <div style={{
                              position: 'absolute',
                              top: '50%',
                              left: '50%',
                              transform: 'translate(-50%, -50%)',
                              zIndex: 2
                            }}>
                              <CircularProgress size={20} sx={{ color: '#5AAF9A' }} />
                            </div>
                          )}
                          <img
                            src={item.createdByUserPhoto}
                            alt="no-img-found"
                            className="profilePic"
                            onLoad={() => handleImageLoad(item.voteId, 'profile')}
                            onError={() => handleImageError(item.voteId, 'profile')}
                            onLoadStart={() => setMediaLoading(item.voteId, 'profile', true)}
                            style={{
                              opacity: profileImageLoading[item.voteId] ? 0.3 : 1,
                              transition: 'opacity 0.3s ease'
                            }}
                          />
                        </div>
                      ) : (
                        <div
                          className="profilePic"
                          style={{
                            backgroundColor: getBackgroundColor(getUserInitials(item.displayName)),
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: 'white',
                            fontWeight: 'bold',
                            fontSize: '16px',
                            fontFamily: 'Arial, sans-serif'
                          }}
                        >
                          {getUserInitials(item.displayName)}
                        </div>
                      )}
                      <div className="profileDetails">
                        <span className="profileNameText">{item.displayName ? item.displayName : item.createdByUserName}</span>
                      </div>
                    </div>
                    <div className="timeContainer">
                      {item.isPaused ? <div className="pausedContainer"><span className="pausedtext">Paused</span></div> : <div className="timeContainer"><span className="timeText">{getHumanizedTime(item.createdOn)}</span></div>}
                      <img
                        src="/Assets/Sidebar/helpCenterIcon.svg"
                        alt="no img found"
                        className="infoIcon"
                        onClick={(e) => handleHelpClick(e, item.voteId, item.bookmarkId)}
                      />
                    </div>
                  </div>
                  <div className="voteTitleContainer">
                    <span className="voteTitleText">
                      {item.title}
                    </span>
                  </div>
                  {item?.imageUrls?.[0] && <div className="voteMediaContainer" style={{ position: 'relative' }}>
                    {imageLoading[item.voteId] && (
                      <div style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        zIndex: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        <CircularProgress size={40} sx={{ color: '#5AAF9A' }} />
                      </div>
                    )}
                    {item?.imageUrls?.[0] && <img
                      src={item.imageUrls?.[0]}
                      alt="no-img-found"
                      className="voteMedia"
                      onLoad={() => handleImageLoad(item.voteId, 'main')}
                      onError={() => handleImageError(item.voteId, 'main')}
                      onLoadStart={() => setMediaLoading(item.voteId, 'main-image', true)}
                      style={{
                        opacity: imageLoading[item.voteId] ? 0.3 : 1,
                        transition: 'opacity 0.3s ease'
                      }}
                    />}
                  </div>}
                  {item?.videoUrl && <div className="voteMediaContainer" style={{ position: 'relative' }}>
                    {videoLoading[item.voteId] && (
                      <div style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        zIndex: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        <CircularProgress size={40} sx={{ color: '#5AAF9A' }} />
                      </div>
                    )}
                    <video
                      src={item?.videoUrl}
                      alt="no-video-found"
                      className="voteMedia"
                      muted={unmutedVideoId !== item.voteId}
                      loop
                      onPlay={() => setPlayingVideos(prev => ({ ...prev, [item.voteId]: true }))}
                      onPause={() => setPlayingVideos(prev => ({ ...prev, [item.voteId]: false }))}
                      onLoadStart={() => setMediaLoading(item.voteId, 'main-video', true)}
                      onLoadedData={() => handleVideoLoad(item.voteId, 'main')}
                      onError={() => setVideoLoading(prev => ({ ...prev, [item.voteId]: false }))}
                      onClick={(e) => handleVideoPlayPause(item.voteId, e)}
                      style={{
                        cursor: "pointer",
                        opacity: videoLoading[item.voteId] ? 0.3 : 1,
                        transition: 'opacity 0.3s ease'
                      }}
                    />

                    {/* Play/Pause Button Overlay */}
                    {!playingVideos[item.voteId] && !videoLoading[item.voteId] && (
                      <div
                        className="playPauseOverlay"
                        style={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          cursor: 'pointer',
                          zIndex: 10
                        }}
                        onClick={(e) => handleVideoPlayPause(item.voteId, e)}
                      >
                        <PlayArrowRoundedIcon
                          sx={{
                            color: "#5AAF9A",
                            fontSize: "70px",
                            cursor: "pointer",
                          }}
                        />
                      </div>
                    )}

                    <div className="volumeControlContainer" style={{
                      position: 'absolute',
                      top: '10px',
                      right: '10px',
                      background: 'rgba(0, 0, 0, 0.5)',
                      borderRadius: '50%',
                      padding: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      opacity: videoLoading[item.voteId] ? 0.3 : 1,
                      transition: 'opacity 0.3s ease'
                    }}>
                      {unmutedVideoId === item.voteId ? (
                        <VolumeUpIcon
                          onClick={(e) => handleVolumeToggle(item.voteId, e)}
                          sx={{
                            color: "#fff",
                            fontSize: "20px",
                            cursor: "pointer",
                            "&:hover": { opacity: 0.8 }
                          }}
                        />
                      ) : (
                        <VolumeOffIcon
                          onClick={(e) => handleVolumeToggle(item.voteId, e)}
                          sx={{
                            color: "#fff",
                            fontSize: "20px",
                            cursor: "pointer",
                            "&:hover": { opacity: 0.8 }
                          }}
                        />
                      )}
                    </div>
                  </div>}
                  {
                    item?.fileUrl && item?.fileUrl.endsWith('.pdf') && (
                      <div className="pdfLinkContainer">
                        <a
                          href={`https://drive.google.com/viewerng/viewer?url=${encodeURIComponent(item?.fileUrl)}&embedded=true`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="pdfLink"
                        >
                          <img
                            src="/Assets/Sidebar/pdf-icon.svg"
                            alt="PDF"
                            className="pdfIcon"
                          />
                          View PDF
                        </a>
                      </div>
                    )
                  }
                  <div className="voteDescriptionContainer">
                    <span className="voteDescriptionText">{item.description}</span>
                  </div>
                  <div className="voteBtnsContainer">
                    {item.options.map((option) => (
                      <button
                        key={option.id}
                        className={`vote-button-wrapper ${item.isVoted ? 'voted' : ''} ${option.isSelected ? 'selected' : ''}`}
                        onClick={() => !item.isVoted && handleSubmitVote(item.voteId, option.id)}
                        disabled={item.isVoted || item.isPaused}
                      >
                        {(item.selectedOptionId).toLowerCase() === option.id && (
                          <div
                            className="vote-progress-bar"
                            style={{ width: `${option.percentage}%` }}
                          />
                        )}
                        <span className={`vote-text ${item.isVoted ? 'voted' : ''}`}>{option.value}</span>
                        {item.isVoted && (
                          <span className={`vote-percentage ${item.isVoted ? 'voted' : ''}`}>{option.percentage}%</span>
                        )}
                      </button>
                    ))}
                  </div>
                  <div className="voteDetailsContainer">
                    <div className="voteActionContainer">
                      <div className={`voteActionContainer2 ${item.isLiked ? 'liked' : ''}`} onClick={() => handleLikeDislike(item.voteId)}>
                        {item.isLiked ? (
                          <FavoriteRoundedIcon sx={{ color: "#FF0000", fontSize: { xs: "15px", md: "20px", sm: "15px", lg: "25px" } }} />
                        ) : (
                          <FavoriteBorderRoundedIcon sx={{ color: "#fff", fontSize: { xs: "15px", md: "20px", sm: "15px", lg: "25px" } }} />
                        )}
                        <span className={`feedCardFooterText ${item.isLiked ? 'liked-text' : ''}`}>{item.likeCount}</span>
                      </div>
                      <div className="voteActionContainer2" onClick={() => handleCommentIconClick(item.voteId, item.commentCount)}>
                        <ChatBubbleOutlineRoundedIcon sx={{ color: "#fff", fontSize: { xs: "15px", md: "20px", sm: "15px", lg: "25px" } }} />
                        <span className="feedCardFooterText">{item.commentCount}</span>
                      </div>
                    </div>
                    <div className="voteShareContainer" onClick={() => handleShare(item)}>
                      <NearMeOutlinedIcon sx={{ color: "#fff", fontSize: { xs: "15px", md: "20px", sm: "15px", lg: "25px" } }} />
                    </div>
                  </div>
                  {openComments[item.voteId] && (
                    <div className="commentContainer">
                      <div className="commentInputContainer">
                        <input
                          type="file"
                          ref={fileInputRef}
                          style={{ display: 'none' }}
                          onChange={(e) => handleFileSelect(e, item.voteId)}
                          accept="image/*,video/*"
                          className="feedsCommentInput"
                        />
                        {filePreviews[item.voteId] ? (
                          <div className="filePreviewContainer" style={{ position: 'relative' }}>
                            {previewLoading[item.voteId] && (
                              <div style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                zIndex: 2,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}>
                                <CircularProgress size={30} sx={{ color: '#5AAF9A' }} />
                              </div>
                            )}
                            {selectedFiles[item.voteId]?.type.startsWith('image/') ? (
                              <img
                                src={filePreviews[item.voteId]}
                                alt="Selected"
                                className="filePreview"
                                onLoad={() => handleImageLoad(item.voteId, 'preview')}
                                onError={() => handleImageError(item.voteId, 'preview')}
                                onLoadStart={() => setMediaLoading(item.voteId, 'preview', true)}
                                style={{
                                  opacity: previewLoading[item.voteId] ? 0.3 : 1,
                                  transition: 'opacity 0.3s ease'
                                }}
                              />
                            ) : selectedFiles[item.voteId]?.type.startsWith('video/') ? (
                              <video
                                src={filePreviews[item.voteId]}
                                className="filePreview"
                                muted
                                autoPlay
                                loop
                                onLoadStart={() => setMediaLoading(item.voteId, 'preview', true)}
                                onLoadedData={() => handleVideoLoad(item.voteId, 'preview')}
                                onError={() => setPreviewLoading(prev => ({ ...prev, [item.voteId]: false }))}
                                style={{
                                  opacity: previewLoading[item.voteId] ? 0.3 : 1,
                                  transition: 'opacity 0.3s ease'
                                }}
                              />
                            ) : null}
                          </div>
                        ) : (
                          <textarea
                            placeholder="Add a comment..."
                            className="feedsCommentInput"
                            value={commentText}
                            onChange={(e) => setCommentText(e.target.value)}
                          />
                        )}
                        <div className="commentButtonContainer">
                          <button
                            className="commentButton"
                            onClick={() => filePreviews[item.voteId] ? clearFileSelection(item.voteId) : handlePlusClick()}
                          >
                            {filePreviews[item.voteId] ? (
                              <CloseRoundedIcon sx={{ color: "#070F0F", fontSize: "20px" }} />
                            ) : (
                              <AddRoundedIcon sx={{ color: "#070F0F", fontSize: "20px" }} />
                            )}
                          </button>
                          <button className="commentButton" onClick={() => handleCommentSubmit(item.voteId)}>
                            <SendRoundedIcon sx={{ color: "#070F0F", fontSize: "20px" }} />
                          </button>
                        </div>
                      </div>
                      <div className="existingCommentsContainer">
                        {allComments.length > 0 && allComments.map((comment) => (
                          <div key={comment.commentId} className="commentItem">
                            <div className="commentItemContainer">
                              <div className="commentHeader">
                                {comment.userPhoto ? (
                                  <div style={{ position: 'relative' }}>
                                    {commentProfileLoading[comment.commentId] && (
                                      <div style={{
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        zIndex: 2
                                      }}>
                                        <CircularProgress size={15} sx={{ color: '#5AAF9A' }} />
                                      </div>
                                    )}
                                    <img
                                      src={comment.userPhoto}
                                      alt={comment.userName}
                                      className="commentUserPhoto"
                                      onLoad={() => handleImageLoad(comment.commentId, 'commentProfile')}
                                      onError={() => handleImageError(comment.commentId, 'commentProfile')}
                                      onLoadStart={() => setMediaLoading(comment.commentId, 'commentProfile', true)}
                                      style={{
                                        opacity: commentProfileLoading[comment.commentId] ? 0.3 : 1,
                                        transition: 'opacity 0.3s ease'
                                      }}
                                    />
                                  </div>
                                ) : (
                                  <div
                                    className="commentUserPhoto"
                                    style={{
                                      backgroundColor: getBackgroundColor(getUserInitials(comment.userName)),
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      color: 'white',
                                      fontWeight: 'bold',
                                      fontSize: '14px',
                                      fontFamily: 'Arial, sans-serif'
                                    }}
                                  >
                                    {getUserInitials(comment?.userName)}
                                  </div>
                                )}
                                <div className="commentUserInfo">
                                  <span className="commentUserName">{comment.userName}</span>
                                  <span className="commentTime">
                                    {getHumanizedTime(comment?.createdAt)}
                                  </span>
                                </div>
                              </div>
                              {comment?.videoUrl && <div className="commentVideoContainer" style={{ position: 'relative' }}>
                                {commentMediaLoading[comment.commentId] && (
                                  <div style={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    zIndex: 2,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                  }}>
                                    <CircularProgress size={25} sx={{ color: '#5AAF9A' }} />
                                  </div>
                                )}
                                {comment?.videoUrl?.match(/\.(mp4|webm|ogg)$/i) ? (
                                  <video
                                    src={comment?.videoUrl}
                                    className="commentVideo"
                                    muted
                                    autoPlay
                                    loop
                                    onLoadStart={() => setMediaLoading(comment.commentId, 'comment', true)}
                                    onLoadedData={() => handleVideoLoad(comment.commentId, 'comment')}
                                    onError={() => setCommentMediaLoading(prev => ({ ...prev, [comment.commentId]: false }))}
                                    style={{
                                      opacity: commentMediaLoading[comment.commentId] ? 0.3 : 1,
                                      transition: 'opacity 0.3s ease'
                                    }}
                                  />
                                ) : (
                                  <img
                                    src={comment?.videoUrl}
                                    alt="comment media"
                                    className="commentVideo"
                                    onLoad={() => handleImageLoad(comment.commentId, 'comment')}
                                    onError={() => handleImageError(comment.commentId, 'comment')}
                                    onLoadStart={() => setMediaLoading(comment.commentId, 'comment', true)}
                                    style={{
                                      opacity: commentMediaLoading[comment.commentId] ? 0.3 : 1,
                                      transition: 'opacity 0.3s ease'
                                    }}
                                  />
                                )}
                              </div>}
                              {comment?.commentText?.trim() && <div className="commentText">
                                {comment?.commentText.trim()}
                              </div>}
                              <div className="commentActionsRow" style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '6px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', background: '#2a2a2a', borderRadius: '12px', padding: '2px' }}>
                                  <KeyboardArrowUpRoundedIcon 
                                    sx={{ 
                                      color: comment.isLiked ? "#5AAF9A" : "#808080", 
                                      fontSize: "20px", 
                                      cursor: comment.isLiked ? "default" : "pointer",
                                      "&:hover": { color: comment.isLiked ? "#5AAF9A" : "#ffffff" }
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleCommentLikeDislike(comment.voteId, comment.commentId, 'up');
                                    }}
                                  />
                                  <span style={{ fontSize: '13px', fontWeight: 'bold', color: '#fff', margin: '0 4px', minWidth: '12px', textAlign: 'center' }}>
                                    {comment.likeCount || 0}
                                  </span>
                                  <KeyboardArrowDownRoundedIcon 
                                    sx={{ 
                                      color: !comment.isLiked ? "#808080" : "#808080",
                                      fontSize: "20px", 
                                      cursor: !comment.isLiked ? "default" : "pointer",
                                      "&:hover": { color: !comment.isLiked ? "#808080" : "#ffffff" }
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleCommentLikeDislike(comment.voteId, comment.commentId, 'down');
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                            {comment?.userId === userId && (
                              <div className="commentItemContainer">
                                <button
                                  className="deleteCommentBtn"
                                  onClick={() => handleDeleteComment(comment.commentId, comment.voteId)}
                                >
                                  <DeleteOutlineIcon sx={{ color: "#C15F5F", fontSize: "20px", cursor: "pointer" }} />
                                </button>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Share Dialog */}
      <ShareModal
        open={shareDialogOpen}
        onClose={() => setShareDialogOpen(false)}
        item={selectedVoteForShare}
        shareType="ballot"
        onToast={(msg) => {
          setSnackbarMessage(msg);
          setSnackbarOpen(true);
        }}
      />

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />

      <ProfileCompletionPrompt
        open={profilePromptOpen}
        onClose={() => setProfilePromptOpen(false)}
        message={profilePromptMessage || 'Please verify your Government ID using the Amalgamate mobile app on iOS or Android.'}
        actionLabel="GOT IT"
        secondaryAction={null}
        onPrimaryAction={() => setProfilePromptOpen(false)}
      />

      {/* Face Recognition Dialog */}
      <Dialog
        open={faceRecognitionDialogOpen}
        onClose={() => setFaceRecognitionDialogOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            width: '150%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 3,
            overflow: 'hidden',
            marginTop: '150px',
            backgroundColor: '#0e1b1b',
            position: 'relative',
          }
        }}
      >
        <DialogTitle sx={{ color: 'white', width: '100%', pr: 5, pl: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          Verify your identity
          <CloseIcon
            onClick={() => setFaceRecognitionDialogOpen(false)}
            sx={{
              position: 'absolute',
              right: 16,
              top: 16,
              color: 'white',
              cursor: 'pointer',
              fontSize: 28,
              zIndex: 10,
            }}
            aria-label="close"
          />
        </DialogTitle>
        <FaceRecognition
          isUserVerified={isUserVerified}
          onSuccess={handleFaceRecognitionSuccess}
          onCancel={() => setFaceRecognitionDialogOpen(false)}
        />
      </Dialog>

      {showPopup && (
        <div className="popupOverlay" onClick={handleClickOutside}>
          <div
            className="popupContent"
            style={{
              top: `${popupPosition.top}px`,
              left: `${popupPosition.left}px`
            }}
          >
            <span className="popupTitle">Information</span>
            <button className="popupBtn saveBtn" onClick={() => handleUnSave(selectedCardId)}>
              Unsave
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default SavedVote;
